import { useMemo } from 'react';
import { useProcessing } from '../../../features/processing/context';
import { AnalysisResult } from '../../../features/processing/types';

interface FormattedResult {
  title: string;
  content: string | string[];
}

export function useAnalysisResults() {
  const { state } = useProcessing();
  const { result, isProcessing } = state;

  const formattedResults = useMemo(() => {
    if (!result || isProcessing) {
      return [];
    }

    const analysisResult = result as AnalysisResult;
    const results: FormattedResult[] = [];

    if (analysisResult.sender_bias) {
      results.push({
        title: 'Sender Bias',
        content: [analysisResult.sender_bias],
      });
    }

    if (analysisResult.content_biases?.length > 0) {
      results.push({
        title: 'Content Biases',
        content: analysisResult.content_biases,
      });
    }

    if (analysisResult.stats) {
      const { total_tokens, content_size, duration_ms } = analysisResult.stats;
      
      results.push({
        title: 'Analysis Statistics',
        content: [
          `Total Tokens: ${total_tokens}`,
          `Content Size: ${(content_size / 1024).toFixed(2)}KB`,
          `Duration: ${(duration_ms / 1000).toFixed(2)}s`,
        ],
      });
    }

    if (results.length === 0) {
      results.push({
        title: 'Analysis Complete',
        content: 'No significant biases were detected.',
      });
    }
    return results;
  }, [result, isProcessing]);

  return {
    results: formattedResults,
    hasResults: formattedResults.length > 0,
  };
} 